import { render, staticRenderFns } from "./CustomValue.vue?vue&type=template&id=4f81dffb&"
import script from "./CustomValue.vue?vue&type=script&lang=ts&"
export * from "./CustomValue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports